import { SliceCaseReducers, ValidateSliceCaseReducers, createSlice } from '@reduxjs/toolkit';
import { IFAQState } from '@sv-support-sdk/shared-types/src/store/faq';

export const initialState = {
  categories: [],
  topics: {},
  categoriesLoading: false,
  topicsLoading: {},
} as IFAQState;

const createFaqSlice = <T extends IFAQState, Reducers extends SliceCaseReducers<T>>({
  name = 'faq',
  initialState,
  reducers,
}: {
  name: string;
  initialState: T;
  reducers: ValidateSliceCaseReducers<T, Reducers>;
}) =>
  createSlice({
  name,
  initialState,
  reducers: {
    setCategories: (state, action) => ({
      ...state,
      categories: action.payload,
    }),
    setTopics: (state, action) => ({
      ...state,
      topics: {
        ...state.topics,
        [action.payload.categorySlug]: action.payload.topics,
      },
    }),
    setCategoriesLoading: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.categoriesLoading = action.payload;
    },
    setTopicsLoading: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.topicsLoading[action.payload.categorySlug] = action.payload.value;
    },
    ...reducers
  },
});

export default createFaqSlice;
